import React, { useState } from "react";
import "../index.css";

const ActionAccordionMobile = ({ firstRowButtons, secondRowButtons, style }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div style={{ width: "100%", ...style?.buttonContainer }}>
      {(firstRowButtons.length > 0 || secondRowButtons.length > 0) && (
        <>
          {/* First Row: Always Visible */}
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "10px",
              padding: "5px 0",
              width: "100%",
            }}
          >
            {firstRowButtons.map((button, index) => { 
             if (button && button.key !== "undefined") { /* KAD added to hide missing buttons Sept 23, 2025 */
                return(<div key={index} className="action-button">
                  {button}
                </div>)
              }
            })}
          </div>
          {/* Second Row: Collapsible with Toggle Header */}
          {secondRowButtons.length > 0 && (
            <>
              <div
                className="common-from-sub-heading"
                onClick={() => setIsOpen(!isOpen)}
                style={{ width: "100%" }}
              >
                <div className="leinfo">Actions</div>
                <button
                  type="button"
                  className={isOpen ? "accord-btn active" : "accord-btn"}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={16}
                    height={16}
                    fill="currentColor"
                    className="bi bi-chevron-down"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                    />
                  </svg>
                </button>
              </div>
              <div
                style={{
                  display: isOpen ? "flex" : "none",
                  flexWrap: "wrap",
                  gap: "10px",
                  padding: "5px 0",
                  width: "100%",
                }}
              >
                {secondRowButtons.map((button, index) => (
                  <div key={index} className="action-button">
                    {button}
                  </div>
                ))}
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default ActionAccordionMobile;
